export const ReportsModalTablesStyle = {
	wrapper: {
		background: 'var(--default-white)',
		marginTop: '28px',
		width: '100%',
		height: '100%',
		overflow: 'inherit',
	},
	title: {
		color: 'var(--neutral-500)',
		flex: 1,
		fontWeight: 400,
	},
	search: {
		flex: 1,
		minWidth: '300px',
		position: 'relative',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '8px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			paddingLeft: '40px',

			'&::placeholder': {
				color: 'var(--neutral-500)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			border: 0,
			background: 'var(--background-grey-op-50-1)',
		},
	},
	filterRow: {
		height: '45px',
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
		marginBottom: '12px',
	},
	roleBodyRow: {
		textAlign: 'right',

		h6: {
			color: 'var(--neutral-300)',
		},

		'.MuiSelect-select': {
			padding: '8px !important',
			color: 'var(--primary-500)',
			fontSize: '14px',
		},

		'.MuiInputBase-root fieldset, .MuiInputBase-root:hover fieldset, .MuiInputBase-root.Mui-focused fieldset': {
			border: 'none',

			'&:hover': {
				border: 'none',
			},
		},
		'.MuiBox-root ': {
			marginRight: '0',
		},

		'.MuiInputBase-root svg path': {
			fill: 'var(--primary-500)',
		},
	},
	menu: {
		// width: '50px',

		'&.MuiTableCell-body': {
			padding: '0 5px',
		},
	},

	menuContent: {
		width: '100%',
		padding: '8px 16px',
		textTransform: 'capitalize',
		cursor: 'pointer',

		'&:hover': {
			backgroundColor: 'var(--background-grey-op-50-1)',
		},
	},
	activeButton: {
		background: 'var(--background-grey-op-50-1)',
		padding: '10px 16px',
		fontWeight: 400,
		svg: {
			fill: 'var(--primary-500)',
		},
	},
	button: {
		background: 'var(--background-grey-op-50-1)',
		display: 'flex',
		fontWeight: 400,
		width: '100%',
		padding: '10px 16px',
		color: 'var(--neutral-900)',
		svg: {
			fill: 'var(--neutral-900)',
		},

		'&.MuiButton-root': {},
	},
	download: {
		width: '200px',
	},
	tableStyle: {
		minWidth: 650,
		'.winner': {width: '250px'},
		'.item': {width: '430px'},
		'.Price': {width: '80px'},
		'.Pending': {color: 'var(--warning-600) !important'},
		'.Paid': {color: 'var(--success-700) !important'},
		'.Failed': {color: 'var(--error-700) !important'},

		'.circle-Pending': {background: 'var(--warning-600) !important'},
		'.circle-Paid': {background: 'var(--success-700) !important'},
		'.circle-Failed': {background: 'var(--error-700) !important'},
		'.lastItem': {
			textAlign: 'right',
		},
	},
	paginationContainer: {display: 'flex', justifyContent: 'flex-end', mt: '40px'},
	modalWrapper: {
		'.MuiPaper-root': {
			width: '100%',
			maxWidth: '971px',
			border: '1px solid var(--neutral-200)',
			padding: '48px 48px 32px 48px',
			height: '100%',
		},
	},

	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 46px)',
	},

	loader: {
		position: 'absolute',
		left: 'calc(50% - 25px)',
		top: '200px',
	},

	table: {height: 'calc(100vh - 265px)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'},
};
